import { Component, HostBinding, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SubmoduleCard } from '@prism/prism-shared';

@Component({
    selector: 'submodule-card',
    templateUrl: './submodule-card.component.html',
    styleUrls: ['./submodule-card.component.scss'],
})
export class SubmoduleCardComponent {

    @Input() card!: SubmoduleCard;
    @HostBinding('attr.role') public readonly role = 'link';
    @HostBinding('attr.tabindex') public readonly tabIndex = 0;
    @HostBinding('attr.aria-label') public get ariaLabel(): string {
        return this.card?.name ? `open ${this.card.name}` : 'open module';
    }

    constructor(private router: Router) { }

    @HostListener('click')
    onClick(): void {
        this.router.navigate([this.card.path]);
    }

    @HostListener('keydown', ['$event'])
    onKeydown(event: KeyboardEvent): void {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.onClick();
    }
}
